import { track, analyticsKeys } from '@mobi/account/Utils'

export type BlockDebitCardEvent = {
  interaction_type: 'Block Debit Card' | 'Unblock Debit Card' | 'Cancel Unblock Debit Card'
}

const defaultBlockDebitCardValues: Omit<BlockDebitCardEvent, 'interaction_type'> = {}

export const blockDebitCardTracker = (event: BlockDebitCardEvent) =>
  track(analyticsKeys.accountManagement, event)

export const trackBlockDebitCard = () =>
  blockDebitCardTracker({
    interaction_type: 'Block Debit Card',
    ...defaultBlockDebitCardValues,
  })

export const trackUnblockDebitCard = () =>
  blockDebitCardTracker({
    interaction_type: 'Unblock Debit Card',
    ...defaultBlockDebitCardValues,
  })

export const trackCancelUnblockDebitCard = () =>
  blockDebitCardTracker({
    interaction_type: 'Cancel Unblock Debit Card',
    ...defaultBlockDebitCardValues,
  })
